import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Set document title to match app name
document.title = "FundOrFling";

createRoot(document.getElementById("root")!).render(<App />);
